@if (!isEmpty(series_dict) && tileReady) {
  @if (showVertical) {
    <ng-container [ngTemplateOutlet]="verticalTable"></ng-container>
  }
  @if (!showVertical && timeColumns?.length) {
    <ng-container [ngTemplateOutlet]="horizontalTable"></ng-container>
  }
  <ng-template #verticalTable>
    <table class="series-data-table series-data-table-vertical simple-table">
      <thead>
        @if (config.header_rows.process || config.header_rows.custom_groups) {
          <tr>
            @if (show_time_header_dict['process']) {
              <th class="time-column" [attr.rowspan]="header_row_count">Time</th>
            }
            @for (group of groupList; track group; let i = $index) {
              <th
                class="group-header"
                [attr.colspan]="groupDict[group]?.length || 1"
                [ngClass]="(i % 2 == 0)? 'process-group': 'process-group-alt'">
                {{group}}
                @if (!groupDict?.length) {
                  <i class="info" matTooltip="No series selected for this process"></i>
                }
              </th>
            }
          </tr>
        }
        @if (config.header_rows.name) {
          <tr
            [rowResizable]="format_dict?.['name']"
            (rowResizable)="format_dict['name']['height']=$event">
            @if (show_time_header_dict['name']) {
              <th class="time-column" [attr.rowspan]="header_row_count">Time</th>
            }
            @for (group of groupList; track group) {
              @for (series of groupDict[group]; track series) {
                <th class="vertical-cell"
                  [resizable]="format_dict?.[series.id]"
                  (resizable)="format_dict[series.id].width=$event"
                  [style.height]="(format_dict?.name?.height?(format_dict?.name?.height) : 160) + 'px'">
                  <div class="name-cell"
                    title="{{series_dict[series.id]?.attributes.name}} - {{series_dict[series.id]?.attributes.description}}">
                    @if (config.header_rows.name) {
                      <div
                        [style.width]="(format_dict?.name?.height?(format_dict?.name?.height - 10) : 150) + 'px'">
                        {{(series_dict[series.id]?.attributes.name)}}
                      </div>
                    }
                  </div>
                </th>
              }
            }
          </tr>
        }
        @if (config.header_rows.description) {
          <tr
            [rowResizable]="format_dict?.['description']"
            (rowResizable)="format_dict['description']['height']=$event">
            @if (show_time_header_dict['description']) {
              <th class="time-column" [attr.rowspan]="header_row_count">Time</th>
            }
            @for (group of groupList; track group) {
              @for (series of groupDict[group]; track series) {
                <th class="vertical-cell"
                  [resizable]="format_dict?.[series.id]"
                  (resizable)="format_dict[series.id].width=$event"
                  [style.height]="(format_dict?.['description']?.height?(format_dict?.['description']?.height) : 160) + 'px'">
            <div class="name-cell"
                    title="{{series_dict[series.id]?.attributes.name}} - {{series_dict[series.id]?.attributes.description}}">
                    @if (config.header_rows.description) {
                      <div
                        [style.width]="(format_dict?.['description']?.height?(format_dict?.['description']?.height - 10) : 150) + 'px'">
                        {{(series_dict[series.id]?.attributes.description)}}
                      </div>
                    }
                  </div>
                </th>
              }
            }
          </tr>
        }
        @if (config.header_rows.alias) {
          <tr
            [rowResizable]="format_dict?.alias"
            (rowResizable)="format_dict.alias['height']=$event">
            @if (show_time_header_dict['alias']) {
              <th class="time-column" [attr.rowspan]="header_row_count">Time</th>
            }
            @for (group of groupList; track group) {
              @for (series of groupDict[group]; track series) {
                <th
                  [resizable]="getFirstHeaderRow()===1? format_dict?.[series.id]:{allow_resize:false}"
                  (resizable)="format_dict[series.id].width=$event">
                  <div class="series-edit-button-container">
                    <div>{{series_dict[series.id]?.attributes.alias}}</div>
                    @if (!config.header_rows.edit) {
                      <series-edit-button [series_id]="series.id"></series-edit-button>
                    }
                  </div>
                </th>
              }
            }
          </tr>
        }
        @if (config.header_rows.unit) {
          <tr
            [rowResizable]="format_dict?.unit"
            (rowResizable)="format_dict.unit['height']=$event"
            style="position:relative;">
            @if (show_time_header_dict['unit']) {
              <th class="time-column" [attr.rowspan]="header_row_count">Time</th>
            }
            @for (group of groupList; track group) {
              @for (series of groupDict[group]; track series) {
                <th>
                  <div>
                    {{series_dict[series.id]?.attributes.engineering_unit_name}}
                  </div>
                </th>
              }
            }
          </tr>
        }
        @if (config.header_rows.edit) {
          <tr
            [rowResizable]="format_dict?.edit"
            (rowResizable)="format_dict.edit['height']=$event">
            @if (show_time_header_dict['edit']) {
              <th class="time-column" [attr.rowspan]="header_row_count">Time</th>
            }
            @for (group of groupList; track group) {
              @for (series of groupDict[group]; track series) {
                <th>
                  <series-edit-button [series_id]="series.id"></series-edit-button>
                </th>
              }
            }
          </tr>
        }
      </thead>
      <tbody>
        @if (series_summary && config.show_gss === 'top') {
          <ng-container [ngTemplateOutlet]="series_summary_rows"
            [ngTemplateOutletContext]="{ $implicit: series_summary, config: config }">
          </ng-container>
        }
        @for (time of timeDict | keyvalue; track time.key; let i = $index) {
          <tr class="data-row"
            [rowResizable]="i===0 ? format_dict['time_v']:{allow_resize:false}"
            (rowResizable)="format_dict['time_v'].height=$event"
            [style.height]="format_dict['time_v']?.height + 'px'"
            [style.min-height]="i===0?'':format_dict['time_v']?.height + 'px'">
            <td class="time-column" style="white-space: nowrap;"
              [matTooltip]="(time.value.period_start | stringDate) + ' - ' + (time.value.period_end | stringDate) ">
              {{dtp.sample_period.format(time.value.period_end, dtp)}}
            </td>
            @for (item of groupList; track item) {
              @for (series of groupDict[item]; track series) {
                <td
                  (click)="openChartDialog(series_dict[series.id]?.attributes.name)" style="cursor:pointer;"
                  [matTooltipShowDelay]="TOOLTIP_SHOW_DELAY"
                  [matTooltip]="series_data[time.value.period_end][series_dict[series.id]?.attributes?.name]">
                  @if (series_data[time.value.period_end]) {
                    <div
                 [ngClass]="{'warning': series[time.value.period_end]?.warning, 'error': series[time.value.period_end]?.error,
                'missing': series_missing[time.value.period_end][series_dict[series.id]?.attributes.name]}"
                      [ngStyle]="formats ? formats[series.id][time.value.period_end]?.style : null">
                      {{series_data[time.value.period_end][series_dict[series.id]?.attributes?.name] |
                      formatNumber : format_dict[series.id]?.decimals : true : 3 : false : series_dict[series.id]}}
                    </div>
                  }
                </td>
              }
            }
          </tr>
        }
        @if (series_summary && config.show_gss === 'bottom') {
          <ng-container [ngTemplateOutlet]="series_summary_rows"
            [ngTemplateOutletContext]="{ $implicit: series_summary, config: config }">
          </ng-container>
        }
      </tbody>
    </table>
  </ng-template>
  <!--**Template for Get Series Summary Rows**-->
  <ng-template #series_summary_rows let-series_summary let-config="config">
    @for (column of config.gss?.columns; track $index) {
      <tr
        [rowResizable]="format_dict?.[column]"
        (rowResizable)="format_dict[column]['height']=$event">
        <td class="time-column"
          style="white-space: nowrap;font-weight: bold;">{{gssColumnDict?.[column]?.title || column | upperfirst}}
        </td>
        @for (item of groupList; track item) {
          @for (series of groupDict[item]; track series) {
            <td
              (click)="openChartDialog(series.attributes.name)" style="cursor:pointer;">
              @if (series_summary[series.id] && column !== 'Sparkline') {
                <div [ngStyle]="format_dict[column]?.style">
                  @if (gssColumnDict[column]?.contentFilter === 'date') {
                    {{series_summary[series.id][column] | stringDate}}
                  } @else {
                    {{series_summary[series.id][column] |
                    formatNumber : format_dict[series.id]?.decimals : true : 3 : false : series_dict[series.id] : column}}
                  }
                </div>
              }
              @if (series_summary[series.id] && column == 'Sparkline') {
                <sparkline [data_points]="series_summary[series.id]['Sparkline']"
                [series_name]="series.attributes.name"></sparkline>
              }
            </td>
          }
        }
      </tr>
    }
  </ng-template>
  <ng-template #horizontalTable>
    <div>
      <table #horizontalSeriesDataTable class="series-data-table series-data-table-horizontal simple-table">
        <thead>
          <tr>
            @for (column of columns; track $index) {
              @if (column==='group') {
                <th class="edit-column-left" [ngClass]="column">
                </th>
              }
              @if (column ==='edit') {
                <th class="edit-column-left" [ngClass]="column"
                  [resizable]="format_dict?.[column]"
                  (resizable)="format_dict[column].width=$event">
                </th>
              }
              @if (!timeColumns.includes(column) && !['edit','group'].includes(column)) {
                <th
                  [ngClass]="{'is-sticky-left':isSticky[column]}"
                  [resizable]="format_dict?.[column]"
                  (resizable)="format_dict[column].width=$event">
                  <ng-container>{{gssColumnDict?.[column]?.title || column | upperfirst | removeUnderscore}}</ng-container>
                </th>
              }
              @if (timeColumns.includes(column)) {
                <th class="time-column-vertical" style="font-weight:normal;"
                  [resizable]="getFirstTimeColumn() === column ? format_dict['time_h']:{allow_resize:false}"
                  (resizable)="format_dict['time_h'].width=$event"
                  [style.width]="format_dict['time_h']?.width + 'px'"
                  [style.min-width]="getFirstTimeColumn() === column?'':format_dict['time_h'].width + 'px'"
                  [matTooltip]="(timeDict[column]?.period_start | stringDate) + ' - ' + (timeDict[column]?.period_end | stringDate) ">
                  <ng-container>{{timeDict[column]?.title}}</ng-container>
                </th>
              }
            }
          </tr>
        </thead>
        <tbody>
          @for (group of groupList; track group; let groupIndex = $index) {
            @for (series of groupDict[group]; track series; let seriesIndex = $index) {
              <tr
                [rowResizable]="format_dict?.[series.id]"
                (rowResizable)="format_dict[series.id]['height']=$event">
                @for (column of columns; track $index) {
                  @if (column!=='group') {
                    <td
                      [ngStyle]="formats && timeColumns.includes(column) ? formats[series.id][column]?.style : null"
                      [ngClass]="{'is-sticky-left':isSticky[column], 'edit-column-left': column==='edit','with-edit':columns.includes('edit')}">
                      @if (column==='edit') {
                        <div>
                          <series-edit-button [series_id]="series.id"></series-edit-button>
                        </div>
                      }
                      @if (['name','description','alias'].includes(column)) {
                        <div class="series-column">{{series_dict[series.id]?.attributes[column]}}</div>
                      }
                      @if (column==='unit') {
                        <div class="series-column">{{series_dict[series.id]?.attributes.engineering_unit_name}}</div>
                      }
                      @if (gssColumns?.includes(column) && series_summary?.[series.id]) {
                        @if (column !== 'Sparkline') {
                          <div class="gss-column" [ngStyle]="format_dict[column]?.style"
                            (click)="openChartDialog(series.attributes.name)"
                            style="cursor:pointer;">
                            @if (gssColumnDict[column]?.contentFilter === 'date') {
                              {{series_summary[series.id][column] | stringDate}}
                            } @else {
                              {{series_summary[series.id][column] |
                              formatNumber : format_dict[column]?.decimals : true : 3 : false : series_dict[series.id] : column}}
                            }
                          </div>
                        }
                        @if (column == 'Sparkline') {
                          <sparkline [data_points]="series_summary[series.id]['Sparkline']"
                          [series_name]="series.attributes.name"></sparkline>
                        }
                      }
                      @if (timeColumns.includes(column)) {
                        <div
                          (click)="openChartDialog(series.attributes.name)"
                     [ngClass]="{'warning': series[column]?.warning, 'error': series[column]?.error,
                'missing': series_missing[column][series_dict[series.id].attributes.name]}"
                          style="cursor:pointer;" [ngStyle]="formats ? formats[series.id][column]?.style : null">
                          {{series_data[column][series.attributes.name]|
                          formatNumber : format_dict[series.id]?.decimals : true : 3 : false : series_dict[series.id]}}
                        </div>
                      }
                    </td>
                  }
                  @if (column==='group' && seriesIndex===0) {
                    <td
                      #groupCell
                      class="group-header vertical-group-header vertical-cell"
                      [attr.rowspan]="groupDict?.[group]?.length || 1"
                      [ngClass]="(groupIndex % 2 == 0)? 'process-group': 'process-group-alt'"
                      [style.height]="'24px'">
                      <div class="rotated-label" [matTooltip]="group">
                        <div [style.width]="'24px'"><span class="vertical-text">{{group}}</span>
                        @if (!groupDict?.[group]?.length) {
                          <i class="info"
                          matTooltip="No series selected for this process"></i>
                        }
                      </div>
                    </div>
                  </td>
                }
              }
            </tr>
          }
        }
      </tbody>
    </table>
  </div>
</ng-template>
}


@if (isEmpty(series_dict) && tileReady) {
  Configuration for this tile is incomplete or there was an error fetching your data.
}
